import React, { Children, FC, cloneElement } from 'react';

interface Props {
	id: string;
	value: string[];
	onChange: any;
	onBlur: any;
	children: any;
}

const FormikCheckboxTileGroup: FC<Props> = ({ id, value, onChange, onBlur, children }) => {
	const handleChange = e => {
		const target = e.currentTarget;
		const valueArray = value ? [...value] : [];

		if (target.checked) valueArray.push(target.id);
		else valueArray.splice(valueArray.indexOf(target.id), 1);

		onChange(id, valueArray);
	};

	const handleBlur = () => {
		onBlur(id, true);
	};

	return (
		<div>
			{Children.map(children, child => {
				// @ts-ignore
				return cloneElement(child, {
					field: {
						// @ts-ignore
						value: value ? value.includes(child.props.id) : false,
						onChange: handleChange,
						onBlur: handleBlur,
						groupId: id,
					},
				});
			})}
		</div>
	);
};

export default FormikCheckboxTileGroup;
